import { combineReducers } from 'redux';
import { streetViewsReducer as streetViews } from 'Store/streetViews/streetViews.reducer';
import { customerSearch } from './customer-search/customerSearch.reducer';
import { proposalsReducer as proposals } from './proposals/proposals.reducer';
import { insuranceReducer as insurance } from './proposals/insurance/insurance.reducer';
import { resortReducer as resort } from './resort/resort.reducer';
import { selectedProposalIdReducer as selectedProposalId } from './selected-proposal-id/selectedProposalIdReducer.reducer';
import bestProposalId from './best-proposal-id/bestProposalId.reducer';
import { additionalAccommodations } from './additional-accommodations/additionalAccommodations.reducer';
import additionalTransports from './additional-transports/additionalTransports.reducer';
import paymentProviders from './payment-providers/paymentProviders.reducer';
import { bookingEngineEntry } from './booking-engine-entry/bookingEngineEntry.reducer';
import { attendeesReducer as attendees } from './attendees/attendees.reducer';
import { suggestionsReducer as suggestions } from './suggestions/suggestions.reducer';
import { entryRouteReducer as entryRoute } from './entry-route/entryRoute.reducer';
import { optionValidityReducer as optionValidityDuration } from './option-validity/optionValidity.reducer';
import { travelCompanionReducer as travelCompanion } from './travel-companion/travel-companion.reducer';
import { isProposalLoadingReducer as isProposalLoading } from './proposals/is-proposal-loading.reducer';
export const booking = combineReducers({
  additionalAccommodations,
  additionalTransports,
  attendees,
  bestProposalId,
  bookingEngineEntry,
  customerSearch,
  entryRoute,
  insurance,
  paymentProviders,
  proposals,
  resort,
  selectedProposalId,
  isProposalLoading,
  streetViews,
  suggestions,
  optionValidityDuration,
  travelCompanion,
});
